import styled, { createGlobalStyle } from "styled-components";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { Link, useParams } from "react-router-dom";
import Layout from "../Layout/Layout";
import SindhiFontWoff2 from "../fonts/SHREE-DEV7-0714.woff2";
import SindhiFontWoff from "../fonts/SHREE-DEV7-0714.woff";
import {
  getFilteredStories,
  getStoryCategories,
  getStoryCategoriesforContest,
} from "./utilities/ApiCalls";
import "../css/Stories.css";
import Context from "../Context";
import { parseISO } from "date-fns";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const SindhiFontStyles = createGlobalStyle`
  @font-face {
    font-family: 'SHREE-DEV7-0714';
    src:
      url(${SindhiFontWoff2}) format('woff2'),
      url(${SindhiFontWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

const Stories = (props) => {
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);
  const history = useHistory();
  const { state, dispatch } = useContext(Context);
  const query = new URLSearchParams(props.location.search);

  const { contestId } = useParams();
  const { t } = useTranslation();

  let userId = query.get("userId");

  // noVoting: when true, only show the result countdown — no entries
  const noVoting = query.get("noVoting") === "true";

  const [stories, setStories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  let search = query.get("search");

  const resultDateString = query.get("resultDate");
  // console.log(resultDateString);

  // State to hold the remaining time
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const parseDateString = (dateString) => {
    // Replace the space in the timezone part to make it consistent
    const fixedDateString = dateString.replace(" GMT ", " GMT+");
    return new Date(fixedDateString);
  };

  // Parse the resultDateString using the function
  const resultDate = parseDateString(resultDateString);

  const truncateText = (text, maxLength = 150) => {
    if (!text) return "";
    const plainText = text.replace(/<[^>]+>/g, "");
    if (plainText.length <= maxLength) return plainText;
    return plainText.substring(0, maxLength) + "...";
  };

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const timeDifference = resultDate - now; // Subtract directly

      if (timeDifference <= 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setIsLoading(false);
        return;
      }

      // Calculate remaining time
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      // Set the remaining time
      setTimeLeft({ days, hours, minutes, seconds });
      setIsLoading(false);
    }, 1000);

    return () => {
      clearInterval(timer); // Cleanup the timer on component unmount
    };
  }, [resultDate]);

  useEffect(() => {
    if (noVoting) return; // Skip category fetch when no voting
    let params = { moduleType: 1 };
    getStoryCategoriesforContest().then((response) => {
      setCategories(response.data);
    });
  }, []);

  useEffect(() => {
    if (noVoting) return; // Skip fetching stories when no voting
    fetchStories();
  }, [categoryId, pageNo]);

  useEffect(() => {
    if (noVoting) return;
    setStories([]);
    setPageNo(1);
  }, [categoryId, search]);

  const fetchStories = () => {
    getFilteredStories(contestId, categoryId).then((response) => {
      const newStories = response;
      // console.log(newStories);
      setStories((stories) => [...stories, ...newStories]);
      setLoading(false);
    });
  };

  const handleInfiniteScroll = async () => {
    try {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setLoading(true);
        setPageNo((prev) => prev + 1);
      }
    } catch (err) {
      // console.log(err);
    }
  };

  const formattedTimeLeft = `${String(timeLeft.days).padStart(
    2,
    "0"
  )} Days ${String(timeLeft.hours).padStart(2, "0")}H:${String(
    timeLeft.minutes
  ).padStart(2, "0")}M:${String(timeLeft.seconds).padStart(2, "0")}S`;

  return (
    <Layout>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "transparent",
        }}
      >
        <Root>
          <SindhiFontStyles />
          <div className="stories-container">
            <div className="countdown-container">
              {isLoading ? (
                // Show loading spinner during the 1-second loading phase
                <div className="spinner">
                  <h2>Loading...</h2>
                </div>
              ) : (
                // Show countdown timer after loading is done
                <h2
                  className="countdown-head"
                  style={{ textAlign: "center", padding: "8px" }}
                >
                  Result In {formattedTimeLeft}
                </h2>
              )}
            </div>

            {/* When noVoting is true, only show the countdown — no entries */}
            {!noVoting && (
              <>
                <div className="header">
                  <div className="stories">{t("Stories.Stories")}</div>
                  <div className="select">
                    <select
                      id="categoryDropdown"
                      value={categoryId}
                      onChange={(e) => setCategoryId(e.target.value)}
                      className="drop-down"
                    >
                      <option value="">Genres</option>
                      {categories.map((category) => (
                        <option key={category._id} value={category._id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="grid-container">
                  {stories.length > 0 &&
                    stories.map((data) => {
                      const isSindhiStory =
                        (data.language || "").toLowerCase() === "sindhi";

                      return (
                        <Link
                          to={`/story-details/${data._id}`}
                          key={data._id}
                          style={{ textDecoration: "none" }}
                        >
                          <div className="cart">
                            <div
                              className="title"
                              style={
                                isSindhiStory
                                  ? {
                                      fontFamily: "SHREE-DEV7-0714",
                                      fontSize: "16px",
                                    }
                                  : undefined
                              }
                            >
                              {data.name}
                            </div>
                            {(data.description || data.story) && (
                              <div
                                className={`story-snippet${
                                  isSindhiStory ? " sindhi-text" : ""
                                }`}
                                dangerouslySetInnerHTML={{
                                  __html: truncateText(
                                    data.description || data.story,
                                    150
                                  ),
                                }}
                              ></div>
                            )}
                          </div>
                        </Link>
                      );
                    })}
                </div>
                {stories.length === 0 && (
                  <div style={{ textAlign: "center" }}>{t("Profile.NoStory")}</div>
                )}
                {loading && (
                  <div style={{ textAlign: "center" }}>{t("Home.Loading")}</div>
                )}
              </>
            )}
          </div>
        </Root>
      </div>
    </Layout>
  );
};

export default Stories;

const Root = styled.div`
  min-height: 100vh;
  background-color: transparent;
  height: auto;
  width: 100%;
  display: flex;
  max-width: 1300px;
  position: relative; /* Ensure positioning context for child elements */

  h2 {
    font-size: 30px;
  }
  .countdown-container {
    color: var(--color-text-tertiary, var(--color-text));
    font-size: 25px;
    font-weight: bold;
    padding-top: 25px;
  }
  .stories {
    color: var(--color-text-tertiary, var(--color-text));
    font-size: 25px;
    font-weight: bold;
  }

  .drop-down {
    padding: 4px;
    min-width: 100px;
    width: auto;
    border-radius: 20px;
    color: var(--color-primary);
    z-index: 1; /* Ensure dropdown is above other elements */

    @media (min-width: 350px) and (max-width: 450px) {
      width: 100px;
    }
  }

  .header {
    width: 100%;
    justify-content: space-between;
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    align-items: center;
    margin-top: 20px;
    @media (min-width: 1100px) {
      max-width: 1300px;
      padding-right: 75px;
    }
  }

  .cart {
    width: 100%;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    border-radius: 8px;
    padding: 24px;
    transition: transform 0.3s ease, box-shadow 0.3s ease,
      border-color 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;
    text-align: left;
    color: var(--color-text-tertiary);
    position: relative;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
      border-color: var(--color-primary);
    }
  }

  .title {
    font-size: 14px;
    font-weight: 400;
    color: var(--color-text-tertiary);
    margin: 0;
    line-height: 1.3;
    font-family: "Merriweather", serif;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: left;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding-bottom: 12px;
    margin-bottom: 16px;
    border-bottom: 1px solid var(--color-border);
  }

  .story-snippet {
    font-size: 14px;
    line-height: 1.6;
    color: var(--color-text-tertiary);
    font-family: "Merriweather", serif;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-align: left;

    &::first-letter {
      float: left;
      font-size: 48px;
      line-height: 0.7;
      padding-right: 8px;
      padding-top: 4px;
      font-weight: 400;
      font-style: italic;
      color: var(--color-text-tertiary);
    }

    p {
      margin: 0;
      display: inline;
    }
  }

  .story-snippet.sindhi-text,
  .story-snippet.sindhi-text p,
  .story-snippet.sindhi-text strong,
  .story-snippet.sindhi-text em,
  .story-snippet.sindhi-text u {
    font-family: "SHREE-DEV7-0714", "Merriweather", serif;
    font-size: 16px;
  }

  .grid-container {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    padding: 0 10px;

    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
      padding: 0 4px;
    }
  }

  .btn {
    margin-top: 25px;
    background-color: #bd2130;
    color: white;
    font-weight: semibold;
    border-radius: 20px;
    position: relative; /* Ensure button is positioned correctly */
    z-index: 2; /* Ensure button is above other elements */
    cursor: pointer; /* Ensure button is clickable */
  }
  .adventure-title {
    color: var(--color-text-tertiary, var(--color-text));
    font-size: 30px;
    font-family: "Georgia, serif";
  }

  .sub-title {
    color: var(--color-text-tertiary, var(--color-text));
    font-family: "Georgia, serif";
    @media (min-width: 350px) and (max-width: 400px) {
      font-size: 12px;
      letter-spacing: 0.3px;
    }
  }

  .stories-container {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    background: transparent;
    padding-bottom: 40px;
  }
`;
